import axios from "axios";
import {errorHandler} from "@/services/errorHandler";

export default {
    name: "auth",
    state: {
        currentUser: {},
        allUsers: [],
        userInfo:{
            email: "",
            password: ""
        }
    },
    getters: {
        getCurrentUser: (state) => state.currentUser,
        getAllUsers: (state) => state.allUsers,
        getUserInfo: (state) => state.userInfo,
    },
    mutations: {
        setUserInfo: (state, data) => {
            state.userInfo = { ...data};
        },
        setCurrentUser: (state, data) => {
            state.currentUser = data;
        },
        setAllUsers: (state, data) => {
            state.allUsers = data
        },
        removeUserInfo(state) {
            Object.assign(state, {
                userInfo:{
                    email: "",
                    password: ""
                }
            });
        },
        logOutInfo(state) {
            Object.assign(state, {
                allUsers: [],
                Kazang:{},
                locations:{},
                transactionManager:{},
                currentUser: {},
            });
        }
    },
    actions: {
        async login(context, payload) {
            await context.commit('setUserInfo', payload)
            const url = `${ChickenLittle}auth/login`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload, method})
        },
        verifyOtp(context, payload) {
            const url = `${ChickenLittle}auth/verifyOtp`
            const method = `post`
            return axios.post(url, payload)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err) )
        },
        getUser(context, payload) {
            const userPromise = axios.get(`${ChickenLittle}users/getUser/${payload}`)
                .then(({ data }) => data)
                .catch(err => errorHandler.tomcatError(err));
            return userPromise
                .then(userData => {
                    userData.companyID = userData.companyID || this.companyID;
                    const companyID = userData.companyID;  // Now that user data is available, get companyID
                    const companyLogoPromise = axios.get(`${ChickenLittle}users/getCompanyLogo/${companyID}`)
                        .then(({ data }) => data)  // Assuming data contains the base64 string of the logo
                        .catch(err => errorHandler.tomcatError(err));
                    return companyLogoPromise
                        .then(companyLogoData => ({
                            user: userData,
                            companyLogo: companyLogoData
                        }));
                })
                .catch(err => {
                    console.error('Error fetching user or company logo:', err);
                    throw err;
                });
        },
        getUserDetailsByEmail(context, email) {
            // Get ALL users without filtering by companyID (to handle cases where localStorage has stale companyID)
            return axios.get(`${ChickenLittle}users/getAll`)
                .then(({ data }) => {
                    // Find user with matching email
                    const user = data.find(u => u.email && u.email.toLowerCase() === email.toLowerCase());
                    if (!user) throw new Error("User not found");
                    // companyID IS the API key (UUID string) — no external lookup needed
                    if (user.companyID) {
                        user.companyApiKey = user.companyID;
                    }
                    return user;
                })
                .catch(err => {
                    console.error('Error fetching user by email:', err);
                    throw err;
                });
        },
        getAllUsers(context) {
            let userInfo = JSON.parse(localStorage.getItem("current_user"));
            console.log("getAllUsers - ALL userInfo keys:", Object.keys(userInfo || {}));
            console.log("getAllUsers - full userInfo:", userInfo);
            const userCompanyID = userInfo.usercompanyID || userInfo.companyID || userInfo.companyApiKey;
            console.log("getAllUsers - companyID being sent:", userCompanyID);
            if (!userCompanyID) {
                console.error("Company ID is missing from user data");
                return Promise.resolve([]);
            }
            return axios.get(`${ChickenLittle}users/getAllUsersByCompanyID`, {
                params: {
                    "companyID": userCompanyID
                }
            })
                .then(({ data }) => {
                    context.commit('setAllUsers', data);
                    return data;
                })
                .catch(error => {
                    console.error("Error:", error);
                });
        },
        editUser(context, payload) {
            const userId = payload.id;
            // Create a new object for the request body, excluding the id if it's only needed as a query param
            // Or, if your backend CreateUserRequest DTO can handle an 'id' field (and ignores it or uses it appropriately),
            // you might not need to delete it from the payload.
            // For clarity, let's assume the backend's @RequestBody CreateUserRequest does not expect the 'id' field itself.
            const requestBody = { ...payload };
            delete requestBody.id; // Remove id from the body if it's only a query parameter

            // Construct the URL with the id as a query parameter
            const url = `${ChickenLittle}users/update?id=${userId}`;
            const method = `put`;

            // Send the requestBody as the payload for the PUT request
            return context.dispatch('sendRequest', { url, payload: requestBody, method });
        },
        createUser(context, payload) {
            const url = `${ChickenLittle}users/create`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload,method})
        },
        archiveUser(context, userId) { // Renamed payload to userId for clarity
            // Construct the URL with the id as a query parameter
            const url = `${ChickenLittle}users/archive?id=${userId}`;
            const method = 'delete'; // Method is implicitly DELETE via axios.delete

            // axios.delete typically sends the URL and an optional config object.
            // If your 'sendRequest' action is a wrapper around axios,
            // you might need to adapt this or call axios.delete directly.

            // Option 1: Calling axios.delete directly (if 'sendRequest' is not suitable for DELETE with query params only)
            return axios.delete(url)
                .catch(err => {
                    // It's good practice to also handle the error within the action if possible,
                    // or ensure tomcatError re-throws or returns a rejected Promise
                    // so the component's .catch() can also react.
                    errorHandler.tomcatError(err);
                    return Promise.reject(err); // Ensure the promise chain is broken on error
                });

            // Option 2: If your 'sendRequest' action can handle DELETE with query params and no body:
            // return context.dispatch('sendRequest', { url, method /*, payload: undefined if sendRequest expects it */ })
            //   .catch(err => errorHandler.tomcatError(err)); // Assuming sendRequest also returns a promise
        },
        /**
         * Request a password-reset code for the email address the operator
         * typed into the forgot-password dialog.
         *
         * PAYLOAD SHAPE (CG-6 / D3 payload contract):
         *   The dispatched value is the email address itself, as a plain
         *   string, taken from the forgot-password dialog
         *   (LoginForm.vue:92 -> dispatch('userResetPassword', input)). It
         *   travels as the `email` query parameter, not as a request body.
         *
         * FROZEN IDENTITY CONTRACT (TicketApp #29691, task 003 - the PLAN.md
         * task 003 "FROZEN CONTRACT (do not modify)" marker, coordinator
         * ratification 2026-11-03):
         *   A FRESH `localid` is minted for EVERY call, here on the query
         *   string of a DIRECT `axios.put`. This action deliberately does NOT
         *   route through `sendRequest`, so the login-side identity lifecycle
         *   (store/index.js) does not apply to it and must never be
         *   "corrected" into it. The fresh-per-call key is what makes the
         *   operator retry work: a stable key would leave the row of the
         *   first failed attempt UNANSWERED and turn the retry into a 409
         *   `Retry-After` conflict whose text contradicts the failure
         *   guidance the reset screen gives. The same contract is stated -
         *   and must be honoured - in the task 002 submit-handler JSDoc
         *   (ResetPassword.vue:374-388, commit 56edfaa).
         *
         * @param {string} payload - The email address of the account that is
         *   being reset.
         * @returns {Promise} Resolves with the backend response; rejects with
         *   the unwrapped, human-readable error when the request fails.
         */
        userResetPassword(context, payload) {
            // WHY the email is percent-encoded here: this URL is assembled as
            // a string, and axios does NOT encode a query string that is
            // already part of the URL - it only serializes its own `params`
            // option. A `+` in the local part of an address (which the
            // SweetAlert2 email validator allows) decodes to a space
            // server-side, so the user lookup misses and the operator is told
            // that no such user was found instead of being sent a reset code
            // (TicketApp #29691, finding C2-URL-1).
            return axios.put(`${ChickenLittle}auth/resetPassword?email=${encodeURIComponent(payload)}&localid=${generateUUID()}`)
            // WHY no `isSweetalert` flag here: this is the REQUEST leg of the
            // reset and it runs inside the forgot-password dialog, which has
            // no error dialog of its own to fall back on, so the failure has
            // to be surfaced by the SHARED handler. Passing the flag would
            // suppress the shared dialog and leave the SweetAlert2 confirm
            // button spinning forever - its `preConfirm` rejection path never
            // hides the loader and never re-enables the buttons
            // (sweetalert2 11.18.0, src/buttons-handlers.js:146-172). The
            // shared dialog replaces the request dialog and stays open
            // (services/errorHandler.js, task 005) and its text is rendered
            // inertly (services/responses.js, task 006), so the operator does
            // get a visible terminal state (SPEC §7.3).
            .catch(err => errorHandler.tomcatError(err) )
        },
        /**
         * Submit a password reset: the 6-digit WhatsApp code and the new
         * password.
         *
         * PAYLOAD SHAPE (CG-6 / D3 payload contract):
         *   The dispatched object is `{ token, newPassword }` - `token` is the
         *   wire name of the 6-digit code, not a delivery channel. This
         *   action ADDS one property to that very object (`localID`) and
         *   sends the object as the JSON request body of a DIRECT
         *   `axios.put`. The backend binds `token` and `newPassword` only.
         *
         * FROZEN IDENTITY CONTRACT (TicketApp #29691, task 003 - the PLAN.md
         * task 003 "FROZEN CONTRACT (do not modify)" marker, coordinator
         * ratification 2026-11-03):
         *   * `payload.localID` is a FRESH UUID for EVERY call. The mutation
         *     is IN PLACE, on the object owned by the caller, and that is
         *     intentional: the reset screen keeps every piece of screen state
         *     that is not part of the wire payload outside that object
         *     precisely because of it. It must not be "corrected", renamed or
         *     copied into a separate request-body object.
         *   * This action deliberately does NOT route through `sendRequest`,
         *     so the login-side identity lifecycle (store/index.js) does not
         *     apply to it and must never be "corrected" into it. The same
         *     contract is stated - and must be honoured - in the task 002
         *     submit-handler JSDoc (ResetPassword.vue:374-388, commit
         *     56edfaa).
         *
         * @param {{token: string, newPassword: string}} payload - The reset
         *   code and the new password. `localID` is added to it in place.
         * @returns {Promise} Resolves with the backend response; rejects with
         *   the unwrapped, human-readable error when the request fails.
         */
        confirmReset: async (context, payload) => {
            // WHY the property name is `localID` and not `localid`: the
            // backend binds it into `ResetPasswordRequest.LocalID` (Lombok)
            // and uses it as the `querylogid` cache key
            // (AuthController.java:278-286). Under the production converter
            // (Jackson) `localID` is the name that binds. If the production
            // converter were Gson instead, the key would simply not bind and
            // the request would proceed WITHOUT a cache key - a safe
            // degradation (no cache write, no replay corruption, no crash),
            // never a broken one (SPEC §8, CG-6 / OQ-2).
            //
            // WHY the pointer names the cache operations and not the whole
            // method: task 008 (commit ed0ab50, backend repo) inserted the
            // CG-6 null-binding guard AHEAD of them. The guard reads
            // `request.getLocalID()` first and, when the key is unbound,
            // returns on the cache-free path - so an unbound key skips the
            // cache operations entirely (no lookup, no insert, no update)
            // instead of writing a keyless row into querylogid.
            payload.localID = generateUUID();
            return await axios.put(`${ChickenLittle}auth/confirmReset`, payload)
                // WHY the `isSweetalert` flag is passed HERE: this is the
                // SUBMIT leg of the reset and the reset screen owns the
                // error dialog for it (its own-modal guarantee, task 002).
                // Without the flag the shared handler would render the same
                // failure a second time in its own dialog, so the operator
                // would read the same error twice. With the flag the shared
                // handler opens NO dialog, leaves the dialog owned by the
                // caller untouched, and still re-throws the unwrapped error
                // - the re-thrown Error carries the SAME message that was
                // rendered, which is what the failure detail on the screen
                // reads (ResetPassword.vue, `readableFailureDetail`; finding
                // C2-ERR-2). The rejection still propagates, so the catch of
                // the caller still fires.
                .catch(err => errorHandler.tomcatError(err, true) )
        },
    }
}